import React from 'react'
import { Navbar, Nav, Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const SideNavCredit = () => {
    return (
        <>
            <div className='sidenav-body'>
                <Navbar className='sidebar-navigation'>
                    <Container className='sidebar-container'>
                        <Nav className="justify-content-center sidenav">
                            <h4 className='h4sidelink'>सम्वन्धित पेजहरु : :</h4>
                            <Nav.Link as={Link} to='/service/loan-service/general-agriculture-loan' className='sidelink' onClick={() => window.scrollTo({ top: '0' })}>
                                <span>साधारण कृषि कर्जा</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to='/service/loan-service/byabasahik-agriculture-loan' className='sidelink' onClick={() => window.scrollTo({ top: '0' })}>
                                <span>व्यवसायिक कृषि ऋण</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to='/service/loan-service/business-loan' className='sidelink' onClick={() => window.scrollTo({ top: '0' })}>
                                <span>व्यापारिक ऋण</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to='/service/loan-service/home-loan' className='sidelink' onClick={() => window.scrollTo({ top: '0' })}>
                                <span>घर निमार्ण ऋण</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to='/service/loan-service/land-loan' className='sidelink' onClick={() => window.scrollTo({ top: '0' })}>
                                <span>घर जग्गा खरिद ऋण</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to='/service/loan-service/foreign-loan' className='sidelink' onClick={() => window.scrollTo({ top: '0' })}>
                                <span>बैदेशिक रोजगार ऋण</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to='/service/loan-service/education-loan' className='sidelink' onClick={() => window.scrollTo({ top: '0' })}>
                                <span>शैक्षिक ऋण</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to='/service/loan-service/vehicle-loan' className='sidelink' onClick={() => window.scrollTo({ top: '0' })}>
                                <span>सवारी साधन ऋण</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to='/service/loan-service/samajik-sanskar-loan' className='sidelink' onClick={() => window.scrollTo({ top: '0' })}>
                                <span>सामाजिक संस्कार ऋण</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to='/service/loan-service/laghu-udyam-loan' className='sidelink' onClick={() => window.scrollTo({ top: '0' })}>
                                <span>लघु उद्यम ऋण</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to='/service/loan-service/laghu-bittiya-loan' className='sidelink' onClick={() => window.scrollTo({ top: '0' })}>
                                <span>लघु वित्त आयआर्जन ऋण</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to='/service/loan-service/aaya-arjan-loan' className='sidelink' onClick={() => window.scrollTo({ top: '0' })}>
                                <span>आयआर्जन ऋण ( बचत जमानत )</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to='/service/loan-service/aakasmik-loan' className='sidelink' onClick={() => window.scrollTo({ top: '0' })}>
                                <span>आकस्मिक ऋण</span>
                            </Nav.Link>
                        </Nav>
                    </Container>
                </Navbar>
            </div>
        </>
    )
}

export default SideNavCredit